import { atom, useRecoilValue, useSetRecoilState, useResetRecoilState } from 'recoil';
import { SignUpState, UseSignUpState, UseUpdateSignUpState } from './sign-up.types';

export const signUpState = atom<SignUpState>({
  default: {
    remoteValidationError: '',
    rut: '',
    signUpStatus: 'SIGN_UP',
  },
  key: 'signUpState',
});

export const useSignUpState = (): UseSignUpState => useRecoilValue(signUpState);

export const useUpdateSignUpState = (): UseUpdateSignUpState => {
  const setState = useSetRecoilState(signUpState);
  const reset = useResetRecoilState(signUpState);
  const state = useSignUpState();

  return {
    errorSignUp: () => setState(state => ({ ...state, signUpStatus: 'SIGN_UP_EXIST_USER_ERROR' })),
    forbiddenSignUp: () => setState(state => ({ ...state, signUpStatus: 'SIGN_UP_FORBIDDEN' })),
    reset,
    setRemoteValidationError: (remoteValidationError: string = '') => {
      if (state.remoteValidationError !== remoteValidationError) {
        setState(state => ({ ...state, remoteValidationError }));
      }
    },
    setRut: (rut: string) => setState(state => ({ ...state, rut })),
    successSignUp: () => setState(state => ({ ...state, signUpStatus: 'SUCCESS_SIGN_UP' })),
  };
};
